








































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { logout } from "../auth";
import consts from "../consts";
import { User, Team } from "../types";
import axios from "axios";
import { Getter } from "vuex-class";

@Component
export default class UserSettings extends Vue {
  @Getter private JWT?: string;
  @Getter private UID?: string;
  @Getter private userByID!: (uid: string) => User;
  @Getter private currentTeamID!: string;
  @Getter private currentTeam!: Team;
  @Prop() private changeTeam!: (teamID: any) => any;
  private currUser!: User;
  private code: string = "";
  private validUntil: string | null = null;
  private preferencesModalShow: boolean = false;
  private journeyEnabled: boolean = false;
  private unlockAllLessons: boolean = false;
  private error: boolean = false;
  private errorMsg: string = "Please correct the highlighted fields";
  private options: any = [
    { text: "Show Custom Team Lessons", value: "teaml" },
    { text: "Show Orai Journey", value: "journeyl" },
  ];
  private selectedLessonOption: any = "";

  private created() {
    if (this.UID) {
      this.currUser = this.userByID(this.UID);
    }
    console.log("created userSettings");
    this.fetchData();
  }

  private fetchData() {
    this.fetchTeamCode();
    this.fetchTeamById();
  }

  private fetchTeamById() {
    axios
      .get(consts.serverURL + "team/" + this.currentTeamID, {
        headers: { Authentication: this.JWT },
      })
      .then((resp) => {
        this.unlockAllLessons = resp.data.UnlockLessons;
        this.journeyEnabled = resp.data.JourneyEnabled;
        console.log("Journey Enabled", resp.data.JourneyEnabled);
        this.selectedLessonOption = resp.data.JourneyEnabled
          ? "journeyl"
          : "teaml";
        console.log();
      })
      .catch(() => {
        this.error = true;
        this.errorMsg = "Error while fetching team data.";
      });
  }

  @Watch("selectedLessonOption")
  private changeLessonOption() {
    this.journeyEnabled = this.selectedLessonOption === "journeyl";
    console.log(this.selectedLessonOption, this.journeyEnabled);
  }

  private logout() {
    logout();
    this.$router.push({ name: "login" });
  }

  private fetchTeamCode() {
    if (this.currentTeamID) {
      axios
        .get(consts.serverURL + "team/" + this.currentTeamID + "/code", {
          headers: { Authentication: this.JWT },
        })
        .then((resp) => {
          console.log("TEAM CODE", resp.data);
          if (resp.data) {
            this.code = resp.data.Code;
            if (resp.data.ValidUntil) {
              this.validUntil = resp.data.ValidUntil.substring(0, 10);
            }
          } else {
            this.code = "N/A";
            this.validUntil = null;
          }
        });
    }
  }

  /* private saveTeamById() {
    return axios({
      method: "PUT",
      url: consts.serverURL + "team/" + this.currentTeamID,
      headers: { Authentication: this.JWT },
      data: {
        UnlockLessons: this.unlockAllLessons,
        JourneyEnabled: this.journeyEnabled
      }
    });
  } */

  private saveTeamById() {
    axios({
      method: "PUT",
      url: consts.serverURL + "team/" + this.currentTeamID,
      headers: { Authentication: this.JWT },
      data: {
        UnlockLessons: this.unlockAllLessons,
        JourneyEnabled: this.journeyEnabled,
      },
    }).then((resp) => {
      this.error = false;
      this.preferencesModalShow = false;
    });
  }

  private saveCode() {
    if (this.code.length && this.code !== "N/A") {
      // Add time to date
      let validUntil = this.validUntil;
      if (validUntil && validUntil.length === 10) {
        validUntil += "T00:00:00Z";
      }
      axios({
        method: "PUT",
        url: consts.serverURL + "team/" + this.currentTeamID + "/code",
        headers: { Authentication: this.JWT },
        data: {
          Code: this.code,
          validUntil: validUntil,
        },
      })
        .then((resp) => {
          this.saveTeamById(); /* .then(resp => {
            this.error = false;
            this.preferencesModalShow = false;
          }); */
        })
        .catch((error) => {
          console.log(error, error.response);
          this.error = true;
          this.errorMsg = error.response.data.Error;
        });
    } else {
      //this.error = true;
      this.saveTeamById();
    }
  }

  private deleteCode() {
    axios({
      method: "DELETE",
      url: consts.serverURL + "team/" + this.currentTeamID + "/code",
      headers: { Authentication: this.JWT },
    }).then((resp) => {
      console.log("DELETE TEAM CODE", resp);
      this.code = "N/A";
    });
  }

  get userName() {
    if (this.currUser && this.currUser.Name) {
      return this.currUser.Name;
    } else {
      return null;
    }
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    console.log("userSettings oncurrentTeamId");
    if (newVal && newVal !== oldVal) {
      console.log("userSettings oncurrentTeamId if true");
      this.fetchData();
    }
  }
}
